import React, {Component} from 'react';
import {HeaderAndFooterLayout} from "../../module";
import {createTheme, ThemeProvider} from "@mui/material/styles";

const theme = createTheme();

const AppWrapper = ({children }) =>{
        return (
            <ThemeProvider theme={theme}>
                <HeaderAndFooterLayout>
                    {children}
                </HeaderAndFooterLayout>
            </ThemeProvider>
        );
}

export default AppWrapper;
